export const clamp01 = (value: number): number =>
  value < 0 ? 0 : value > 1 ? 1 : value;

export const easeOutCubic = (p: number): number => 1 - (1 - p) ** 3;

export const easeInOutCubic = (p: number): number =>
  p < 0.5 ? 4 * p * p * p : 1 - (-2 * p + 2) ** 3 / 2;

/**
 * About 7% past the target and back. Used by the resolved checkmark and the
 * chart's bars.
 */
export const easeBackOut = (p: number): number => {
  const overshoot = 0.9;
  const x = p - 1;
  return 1 + (overshoot + 1) * x * x * x + overshoot * x * x;
};
